import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useEffect } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    return {
        signInPageUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        isAuthenticated,
    };
};

type Props = PageProps & ReturnType<typeof mapStateToProps>;

export interface OsnCheckOrderStatusPageStyles {}

export const osnCheckOrderStatusPageStyles: OsnCheckOrderStatusPageStyles = {};

const Page = ({ id, isAuthenticated, signInPageUrl }: Props) => {
    const history = useHistory();
    useEffect(() => {
        if (!isAuthenticated) {
            history.push(signInPageUrl || "/");
        }
    }, []);

    return (
        <MobiusPage>
            <Zone contentId={id} zoneName="Content"></Zone>
        </MobiusPage>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps)(Page),
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
